import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { homePageData } from '../../redux/page/pageActions'
//MUI Imports
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
//Icons
import InstagramIcon from '@material-ui/icons/Instagram';
//Page Level Component
import HomeLayout from "../../layouts/HomeLayout";
import TopCats from '../../components/Page/Home/TopCats'
import ArticleCarousel from '../../components/Entities/Articles/Carousel'
import ProductCarousel from '../../components/Entities/Product/Carousel'
import * as TextLoader from '../../components/StaticTexts/Index'

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1334,
            marginTop: '-80px',
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: '10px',
        }
    },
    base: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: 'transparent !important',
        border: 'none !important',
        boxShadow: 'none',
    },
    btn: {
        backgroundColor: '#950000',
        fontWeight: '700',
        '&:hover': {
            backgroundColor: "#950000",
        },
        color: '#fff',
        width: '150px'
    },
    grayBox: {
        backgroundColor: '#f2f2f2'
    },
    whiteBox: {
        backgroundColor: '#ffffff'
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    topSales: {
        [theme.breakpoints.up("sm")]: {
            marginTop: '50px',
        },
        [theme.breakpoints.down("xs")]: {
            marginTop: '50px',
        },
    },
    articles: {
        [theme.breakpoints.up("sm")]: {
            marginTop: '80px',
        },
        [theme.breakpoints.down("xs")]: {
            marginTop: '40px',
        },
    },
    socialBox: {
        marginTop: '30px',
        [theme.breakpoints.down("xs")]: {
            marginTop: '10px',
        },
    },
    socialBox2: {
        marginTop: '30px',
        [theme.breakpoints.down("xs")]: {
            marginTop: '5px',
        },
    },
    topCats: {
        [theme.breakpoints.up("md")]: {
            marginTop: '40px',
        },
        "@media (max-width > 1200px)": {
            marginTop: '140px',
        },
    },
    carouselContiner: {
        backgroundColor: '#f2f2f2',
        [theme.breakpoints.up("sm")]: {
            padding: '40px'
        },
        [theme.breakpoints.down("xs")]: {
            padding: '50px 10px 40px 10px'
        },
    },
    newestBox: {
        [theme.breakpoints.up("sm")]: {
            marginTop: '45px'
        },
        [theme.breakpoints.down("xs")]: {
            marginTop: '45px'
        },
    },
    carouselC: {
        backgroundColor: '#f2f2f2',
        [theme.breakpoints.up("sm")]: {
            padding: '10px 40px 40px 40px'
        },
        [theme.breakpoints.down("xs")]: {
            padding: '50px 10px 40px 10px'
        },
    },
    productCarousel: {
        backgroundColor: '#f2f2f2',
        [theme.breakpoints.up("sm")]: {
            padding: '40px',
            marginLeft: '40px',
            marginRight: '40px'
        },
        [theme.breakpoints.down("sm")]: {
            padding: '50px 5px 40px 5px',
            marginLeft: '4px',
            marginRight: '4px'
        },
    },
    articleCarousel: {
        [theme.breakpoints.down("xs")]: {
            marginTop: '50px'
        },
    }
}));

const Home = ({ lang }) => {

    const [staticText, setStaticText] = useState({});
    const classes = useStyles();
    const dispatch = useDispatch();

    //redux
    const homePage = useSelector(state => state.homePage)
    const { loading, error, categories, topSales, newest, articles } = homePage

    useEffect(() => {
        setStaticText(TextLoader.staticTextLoader("homepage", lang))
        dispatch(homePageData(lang))
    }, [dispatch])

    try {
        return (
            <>
                <HomeLayout lang={lang} metas={{
                    keywords:
                        "پسته ,فندق,آجیل , عید , پاستیل , زعفران , شیرینی , آلوچه ,لواشک ,بادام , مغز ,مغز گردو ,گردو , تخمه , پشمک , شکلات ,ماش ,لوبیا ",
                    description:
                        "فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...",
                    subject: "nuts",
                    copyright: "Ajilhassanpour",
                    language: lang,
                    robots: "index,follow",
                    abstract:
                        "فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...",
                    topic: "nuts",
                    summary: "آجیل حسن پور ",
                    Classification: "E-COMMERCE",
                    copyright: "ajilhassanpour.com",
                    url: window.location.href,
                    directory: "submission",
                    category: "nuts",
                    coverage: "Worldwide",
                    distribution: "Global",
                    "og:title": " آجیل حسن پور ",
                    "og:type": "article",
                    "og:url": window.location.href,
                    "og:image":
                        "https://ajilhassanpour.com/images/home-page-header/logo.png",
                    "og:site_name": "آجیل حسن پور",
                    "og:description":
                        "فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...",
                }}>
                    <Grid container className={classes.base + ' home ' + lang} justify="center" alignItems="center">
                        <Grid container justify="center" alignItems="top" className={classes.container} >

                            <Grid item xs={12} className={lang}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box evelation={0} mt={3} className={classes.topCats}>
                                        <TopCats loading={loading} lang={lang} categories={categories} />
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} className={classes.topSales}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box boxShadow={1} p={{ lg: 3, md: 4, sm: 2, xs: 1 }} m={{ lg: 3, md: 3, sm: 2, xs: 1 }} borderColor='#f2f2f2' border={1} borderRadius={16} className={classes.productCarousel}>
                                        <div className="newTitle" style={{ backgroundImage: "url(/images/home/title.png)" }}>
                                            <h2>{staticText.bestSalesTitle}</h2>
                                        </div>
                                        <div className="productsList">
                                            <ProductCarousel products={topSales} lang={lang} loading={loading} />
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item md={6} xs={12} className={classes.socialBox}>
                                <Paper alignItems="right" className={classes.paper}>
                                    <Box evelation={0} m={{ md: 1, xs: 0 }}>
                                        <div className="homepage-insta-follow-box">
                                            <a rel="nofollow" href='https://instagram.com/ajilhassanpour' target='_blank'>
                                                <div className="contentWarapper">
                                                    <div className="right-side">
                                                        <div className="text-center cText">
                                                            <InstagramIcon size={128} color="White" fontSize="large" />
                                                            <img alt="" src="/images/home/instaText.png" className="iText" />
                                                            <h3>{staticText.instaboxText}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="left-side">
                                                        <img alt="" src="/images/home/instaImg.png" className="phoneImg" />
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item md={6} xs={12} className={classes.socialBox2}>
                                <Paper alignItems="right" className={classes.paper}>
                                    <Box evelation={0} m={{ md: 1, xs: 0 }}>
                                        <div className="homePagemagwBox">
                                            <div className="contentWarapper">
                                                <div className="right-side">
                                                    <div className="text-center cText" style={{ textAlign: 'center' }}>
                                                        <h3>{staticText.magBoxtitle}</h3>
                                                        <h4>{staticText.magBoxSecondTitlte}</h4>
                                                        <div className="btnContainer">
                                                            <Link to="/articels">
                                                                <Button className={classes.btn}>{staticText.articelsBoxTitle}</Button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Hidden only={['xs']}>
                                                    <div className="left-side text-left imgC">
                                                        <img alt="" src="/images/home/handFullofNuts.png" className="phoneImg" />
                                                    </div>
                                                </Hidden>
                                            </div>
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} className={classes.newestBox}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box boxShadow={1} p={2} m={{ lg: 3, md: 3, sm: 2, xs: 1 }} borderColor='#f2f2f2' border={1} borderRadius={16} className={classes.productCarousel}>
                                        <div className="newTitle" style={{ backgroundImage: "url(/images/home/title.png)" }}>
                                            <h2>{staticText.newestBoxTitle}</h2>
                                        </div>
                                        <div className="productsList">
                                            <ProductCarousel products={newest} lang={lang} loading={loading} />
                                        </div>

                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} className={classes.articles}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box boxShadow={1} p={2} m={{ lg: 3, md: 3, sm: 2, xs: 1 }} borderColor='#f2f2f2' border={1} borderRadius={16} className={classes.productCarousel + ' aSlides'}>
                                        <div className="newTitle newTitle2" style={{ backgroundImage: "url(/images/home/title.png)" }}>
                                            <h2>{staticText.articelsBoxTitle}</h2>
                                        </div>
                                        <div>
                                            <ArticleCarousel className={classes.articleCarousel} articles={articles} lang={lang} loading={loading} />
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>
                </HomeLayout>
            </>
        )
    } catch (e) {
        return (
            <h1>ERROR</h1>
        )
    }

}

Home.propTypes = {
    lang: PropTypes.string
}

export default Home
